import { ColumnPattern } from '@/common/components/Table'

export const consumptionDataColumns: ColumnPattern[] = [
  { label: 'Data e Hora', value: 'consumed_at' },
  { label: 'Produto', value: 'products' },
  { label: 'Vlr. Total', value: 'total_amount' },
]
